import { cleanText, cleanNumbers, cleanUnsafe } from "@/utils/inputCleaners";

// Clean the typed value directly on the DOM input (caret-preserving) and notify
// Vuetify via a native `input` event so the (possibly Vuex-backed) v-model picks
// up the cleaned value. DOM-level on purpose — value-based @input is unreliable
// when the v-model target is a computed with a custom setter. Avoids keydown
// (Android sends keyCode 229). IME-safe via isComposing.
function onInput(event, clean) {
  const el = event.target;
  if (!el || event.isComposing) return;
  const before = el.value;
  const cleaned = clean(before);
  if (cleaned === before) return; // nothing stripped; also breaks re-dispatch loop
  const caret = el.selectionStart == null ? cleaned.length : el.selectionStart;
  const removed =
    before.slice(0, caret).length - clean(before.slice(0, caret)).length;
  el.value = cleaned;
  const pos = Math.max(0, caret - removed);
  if (el.setSelectionRange) el.setSelectionRange(pos, pos);
  el.dispatchEvent(new Event("input", { bubbles: true }));
}

// Insert cleaned clipboard text at the caret and notify Vuetify via a native
// `input` event so v-model updates. Avoids keydown (Android sends keyCode 229).
function onPaste(event, clean) {
  const cd = event.clipboardData || window.clipboardData;
  if (!cd) return;
  event.preventDefault();
  const el = event.target;
  const ins = clean(cd.getData("text") || "");
  const start = el.selectionStart != null ? el.selectionStart : el.value.length;
  const end = el.selectionEnd != null ? el.selectionEnd : el.value.length;
  el.value = el.value.slice(0, start) + ins + el.value.slice(end);
  el.dispatchEvent(new Event("input", { bubbles: true }));
  const caret = start + ins.length;
  if (el.setSelectionRange) el.setSelectionRange(caret, caret);
}

export default {
  methods: {
    cleanText,
    cleanNumbers,
    cleanUnsafe,
    onInputText(event) {
      onInput(event, cleanText);
    },
    onInputNumbers(event) {
      onInput(event, cleanNumbers);
    },
    onInputUnsafe(event) {
      onInput(event, cleanUnsafe);
    },
    onPasteText(event) {
      onPaste(event, cleanText);
    },
    onPasteNumbers(event) {
      onPaste(event, cleanNumbers);
    },
    onPasteUnsafe(event) {
      onPaste(event, cleanUnsafe);
    }
  }
};
